import script from "./viewAdminCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./viewAdminCompanies.vue?vue&type=script&setup=true&lang=js"

import "./viewAdminCompanies.vue?vue&type=style&index=0&id=a6173cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6173cac"]])

export default __exports__